/**
 * Search constants shared between the nav search UI and the API client.
 *
 * Kept in their own module, free of axios, because axios is ESM in the CRA Jest
 * bundle: importing them from `userApi` would drag axios into the test bundle of
 * every component that needs the minimum length. Same reason `analytics.js` and
 * `lib/errorReporter` avoid it.
 *
 * Must stay in step with `server/users/helpers/userSearch.js` — the server
 * enforces this independently and returns an empty list below it. The client
 * copy exists only to save a round trip that would return nothing.
 */
export const MIN_SEARCH_LENGTH = 2;

/** Debounce before a search request leaves the browser, in ms. */
export const SEARCH_DEBOUNCE_MS = 300;
